import { render, staticRenderFns } from "./d4.vue?vue&type=template&id=8a3a23aa&scoped=true&lang=pug&"
import script from "./d4.vue?vue&type=script&lang=js&"
export * from "./d4.vue?vue&type=script&lang=js&"
import style0 from "./d4.vue?vue&type=style&index=0&id=8a3a23aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3a23aa",
  null
  
)

export default component.exports